import  ScoreManagerRepository from './ScoreManagerRepository'


export default {
  ScoreManager: ScoreManagerRepository
}
